import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";

interface CreateCodeFileDialogProps {
  isCreateFileDialogVisible: boolean;
  setIsCreateFileDialogVisible: (isCreateFileDialogVisible: boolean) => void;
  newFileName: string;
  setNewFileName: (newFileName: string) => void;
  createBlankPythonFile: () => void;
}

const CreateCodeFileDialog = ({
  isCreateFileDialogVisible,
  setIsCreateFileDialogVisible,
  newFileName,
  setNewFileName,
  createBlankPythonFile,
}: CreateCodeFileDialogProps) => {
  return (
    <Dialog
      visible={isCreateFileDialogVisible}
      style={{ width: "400px" }}
      header="Create Blank Python File"
      modal
      onHide={() => setIsCreateFileDialogVisible(false)}
    >
      <div className="flex flex-column gap-2">
        <label className="font-medium">File Name</label>
        <InputText
          value={newFileName}
          onChange={(e) => setNewFileName(e.target.value)}
          placeholder="Enter file name"
        />
        <Button
          label="Create"
          icon="pi pi-check"
          className="p-button-primary"
          onClick={createBlankPythonFile}
        />
      </div>
    </Dialog>
  );
};

export default CreateCodeFileDialog;
